export default "/images/vendor/@coreui/icons/svg/flag/cif-jo.svg?be28c0809faf82b1caf22b436c26d491";